export const TAG_MANAGER_SCRIP_URL =
  'https://www.googletagservices.com/tag/js/gpt.js';
export const SHAKA_PLAYER_SCRIPT_URL =
  '//cdnjs.cloudflare.com/ajax/libs/shaka-player/3.1.1/shaka-player.compiled.js';
export const GOOGLE_IMA_SCRIPT_URL =
  'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
export const GOOGLE_ADS_SCRIPT_URL =
  '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
